export default __webpack_public_path__ + "static/media/basic-push-pin-15.1cd5a458.png";